import { BaseAssessment } from 'types/api';
import { GraphTabs } from 'components/GraphTabs';
import styles from './Mechanics.module.css';
import { useConfig } from './useConfig';
import { useRightKneeData } from './useRightKneeData';

interface RightKneeProps {
  assessment: BaseAssessment;
  className?: string;
}

export const RightKnee = (props: RightKneeProps) => {
  const { assessment, className } = props;
  const data = useRightKneeData([assessment]);
  const config = useConfig('Right Knee Mechanics', [assessment], data);
  return (
    <GraphTabs
      className={className}
      config={config}
      defaultTab="barTab"
      headerClassName={styles.header}
      heading="Right Knee Mechanics"
    />
  );
};
